import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LoginResponseModel } from '../models/login-response.model';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(private http: HttpClient, private router: Router) {}

  login(
    email: string,
    telefone: string,
    senha: string
  ): Observable<LoginResponseModel> {
    const body = { email, telefone, senha };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    };

    return this.http.post<LoginResponseModel>(
      `${environment.apiAuthenticate}/Login`,
      body,
      httpOptions
    );
  }

  logout(): Observable<void> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    };
    return this.http.get<void>(
      `${environment.apiAuthenticate}/logout`,
      httpOptions
    );
  }

  /**
   * Decodifica o token JWT e retorna o conteúdo
   * @param token string - Token JWT
   * @returns Objeto decodificado ou null se o token for inválido
   */
  decodeToken(): Observable<any> {
    const httpOptions = {
      withCredentials: true,
    };

    var result = this.http.get(
      `${environment.apiAuthenticate}/profile`,
      httpOptions
    );

    return result;
  }

  /**
   * Verifica se o token contém uma role específica
   * @param role string - Role a ser verificada
   * @param rota string - Rota para redirecionamento
   */
  verificarRoleERedirecionar(role: string, rota: string): void {
    this.decodeToken().subscribe({
      next: (response) => {
        if (response && response.roles && Array.isArray(response.roles)) {
          if (response.roles.includes(role)) {
            this.router.navigate([rota]); // Redireciona para a rota
          }
        }
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  confirmarConta(token: string, id: number): Observable<void> {
    return this.http.get<any>(
      `${environment.apiPessoa}/confirmacaoEmail?token=${token}&id=${id}`
    );
  }
}
